import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      isSearch: false,
      searchModal: false,
      allCheckListTableHeader: [
        { text: 'تاریخ', value: 'date', align: 'center', isGroupable: true },
        {
          text: 'نوع کد',
          value: 'codeType',
          align: 'center',
          isGroupable: true,
        },
        { text: 'کد', value: 'code', align: 'center', isGroupable: true },
        {
          text: 'شماره پلاک',
          value: 'pellak',
          align: 'center',
          isGroupable: true,
        },
        { text: 'شیفت', value: 'shift', align: 'center', isGroupable: true },
        { text: 'وضعیت', value: 'status', align: 'center', isGroupable: true },
        {
          text: 'تکنسین ارشد',
          value: 'seniorTechnesian',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'تکنسین اول',
          value: 'firstTechnesian',
          align: 'center',
          isGroupable: true,
        },
        { text: 'پزشک', value: 'doctor', align: 'center', isGroupable: true },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      allCheckListTableItems: [],
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchFromDate: '',
      searchToDate: '',
      searchVehicleId: null,
      searchSeniorTechnicianId: null,
      searchPreviousSeniorTechnicianId: null,
      searchDrugId: null,
      searchNotSelectedCategoryItemId: null,
      searchIsActive: null,
      isActiveSearchItems: [
        { title: 'فعال', id: 1, val: true },
        { title: 'غیر فعال', id: 2, val: false },
        { title: 'هیچکدام', id: 3, val: null },
      ],
      technesiansList: [],
    };
  },
  computed: {
    isRelatedToDrugOrOnSelectedItems: function () {
      return this.$route?.params?.id;
    },
  },
  methods: {
    goToDetail: function (id) {
      this.$router.push({ name: 'qcCheckListReportDetails', params: { id } });
    },
    makeDataReady: function (data) {
      this.allCheckListTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '';
        let isReserve = '';
        let seniorTechnesian = '';
        let firstTechnesian = '';
        let doctor = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].isReserve) {
          isReserve = 'فعال';
        } else {
          isReserve = 'غیر فعال';
        }
        if (data[i].seniorTechnicianUser) {
          let fName = data[i].seniorTechnicianUser.firstName;
          let lName = data[i].seniorTechnicianUser.lastName;
          seniorTechnesian = fName + ' ' + lName;
        }
        if (data[i].secondTechnicianUser) {
          let fName = data[i].secondTechnicianUser.firstName;
          let lName = data[i].secondTechnicianUser.lastName;
          firstTechnesian = fName + ' ' + lName;
        }
        if (data[i].doctorUser) {
          let fName = data[i].doctorUser.firstName;
          let lName = data[i].doctorUser.lastName;
          doctor = fName + ' ' + lName;
        }
        this.allCheckListTableItems.push({
          date: date,
          codeType:
            data[i].vehicle && data[i].vehicle.vehicleType && data[i].vehicle.vehicleType.title
              ? data[i].vehicle.vehicleType.title
              : '-',
          code: data[i].vehicle && data[i].vehicle.code ? data[i].vehicle.code : '-',
          pellak:
            data[i].vehicle && data[i].vehicle.numberPlate ? data[i].vehicle.numberPlate : '-',
          shift:
            data[i].stationShift && data[i].stationShift.title ? data[i].stationShift.title : '-',
          status: isReserve,
          seniorTechnesian: seniorTechnesian,
          firstTechnesian: firstTechnesian,
          doctor: doctor,
          id: data[i].id,
        });
      }
    },
    //search
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfCheckListsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchVehicleId,
        this.searchSeniorTechnicianId,
        this.searchPreviousSeniorTechnicianId,
        this.searchDrugId,
        this.searchNotSelectedCategoryItemId,
        this.searchIsActive,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.setPreTimes();
      this.searchVehicleId = null;
      this.searchSeniorTechnicianId = null;
      this.searchPreviousSeniorTechnicianId = null;
      this.searchDrugId = null;
      this.searchNotSelectedCategoryItemId = null;
      this.searchIsActive = null;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfCheckListsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchVehicleId,
        this.searchSeniorTechnicianId,
        this.searchPreviousSeniorTechnicianId,
        this.searchDrugId,
        this.searchNotSelectedCategoryItemId,
        this.searchIsActive,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchVehicleId = null;
      this.searchSeniorTechnicianId = null;
      this.searchPreviousSeniorTechnicianId = null;
      this.searchDrugId = null;
      this.searchNotSelectedCategoryItemId = null;
      this.searchIsActive = null;
      this.searchModal = false;
      this.setPreTimes();
    },
    backToDashboard: function () {
      this.$router.push({ name: 'qcCheckListReport' });
    },
  },
};
